import ModalBody from "../../../core/Modal/ModalBody/ModalBody";
import HistoryFilter from "../Filter/HistoryFilter/HistoryFilter";

function HistoryFilterMobile(){
    return <ModalBody>
        <HistoryFilter/>
    </ModalBody>
}
export default HistoryFilterMobile;